export default __webpack_public_path__ + "static/media/sample.79a5c2a6.png";